export default {
  'roles.title': 'Roles',
  'roles.viewRole': 'View Role',
  'roles.copyRole': 'Copy Role',
  'roles.roleName': 'Role Name',
  'roles.privilegesTitle': 'Privileges',
  'roles.newInternalRole': 'New Internal Role',
  'roles.createRoleFail': "Can't create role now. Please try again later",
  'roles.privilegesMissed':
    'Privilege needed - please select required privilege',
  'roles.permissionsMissed':
    'Permission needed - please select at least one permission',
  'roles.roleAlreadyExists':
    'Role name already exist. Please select a new name',
  'roles.roleDescriptionErr': 'Description should be less than 200 characters',
  'roles.roleNameErr': 'Role name should be less than 50 characters',
  'roles.createRoleSuccess': 'New Role: { value } created',
  'roles.updatedRoleSuccess': 'Role: { value } updated successful',
  'roles.helpText':
    'You are editing a temporary record of this role. Please save to avoid losing any changes',
  'roles.cantChangeRoleName':
    'Role name can no longer be changed. Please duplicate or create a new role',
  'roles.updateRoleFail': "Can't update role now. Please try again later",
  'roles.privilegesDescription':
    'Select applications and the respective privileges for this role',
  'roles.airlineGroupRole': 'Airline Group Role',
  'roles.airlineGroupRoleDescription':
    'The role will be applicable to all airlines within the group.',
  'roles.airlineSpecificRole': 'Airline Specific Role',
  'roles.airlineSpecificRoleDescription':
    'The role will be applicable to the selected airlines.',
  'roles.selectAirlines': 'Select one or more applicable Airlines',
  'roles.emptyAirline': 'Please select at least one applicable airline',
  'roles.noRoleSelected': 'Please select at least one applicable airline',
  'roles.applicableAirlines': 'Applicable Airlines',
  'roles.basicDetails': 'Basic Details',
  'roles.roleDescription': 'Role Description',
  'roles.existRoleMsg': 'Role name already exist. Please select a new name',
  'roles.access.microproduct.label': 'Micro Product',
  'roles.access.microproduct.placeholder': 'Search for multiple Micro Products',
  'roles.access.module.label': 'Module',
  'roles.access.module.placeholder': 'Search for multiple Modules',
  'roles.access.privilege.label': 'Privilege',
  'roles.access.privilege.placeholder': 'Search for multiple Privileges',
  'roles.access.validation.emptyRoleDescription':
    'Role description is mandatory',
  'roles.access.validation.invalidRoleName':
    'Role name should be alphanumeric values and a dash symbol only'
};
